// Page orders
export const WELCOME_VIEW = 1;

export const NAME_VIEW = 2;

export const DATA_CONFIRM_VIEW = 3;

export const EMAIL_VERIFY_VIEW = 6;

export const PHONE_VERIFY_VIEW = 5;

export const PASSWORD_VIEW = 7;

export const PROCEDURE_VERIFICATION_VIEW = 4;

export const SUCCESS_VIEW = 8;

export const LOGIN_VIEW = 9;

export const LOGGED_IN_USER_PROCEDURE_VIEW = 10;

export const FORGOT_PASSWORD_VIEW = 11;

export const PASSWORD_RESET_SUCCESS_VIEW = 12;

export const ADD_PROCEDURE_VERIFICATION_VIEW = 13;

export const GET_LOCATION_PROVIDERS_REQUEST_SENT =
  "src/PatientRegister/GET_LOCATION_PROVIDERS_REQUEST_SENT";
export const GET_LOCATION_PROVIDERS_REQUEST_SUCCEED =
  "src/PatientRegister/GET_LOCATION_PROVIDERS_REQUEST_SUCCEED";
export const GET_LOCATION_PROVIDERS_REQUEST_FAILED =
  "src/PatientRegister/GET_LOCATION_PROVIDERS_REQUEST_FAILED";

export const GENERATE_OTP_REQUEST_SENT =
  "src/PatientRegister/GENERATE_OTP_REQUEST_SENT";
export const GENERATE_OTP_REQUEST_SUCCEED =
  "src/PatientRegister/GENERATE_OTP_REQUEST_SUCCEED";
export const GENERATE_OTP_REQUEST_FAILED =
  "src/PatientRegister/GENERATE_OTP_REQUEST_FAILED";

export const VERIFY_OTP_REQUEST_SENT =
  "src/PatientRegister/VERIFY_OTP_REQUEST_SENT";
export const VERIFY_OTP_REQUEST_SUCCEED =
  "src/PatientRegister/VERIFY_OTP_REQUEST_SUCCEED";
export const VERIFY_OTP_REQUEST_FAILED =
  "src/PatientRegister/VERIFY_OTP_REQUEST_FAILED";

export const CREATE_PATIENT_REQUEST_SENT =
  "src/PatientRegister/CREATE_PATIENT_REQUEST_SENT";
export const CREATE_PATIENT_REQUEST_SUCCEED =
  "src/PatientRegister/CREATE_PATIENT_REQUEST_SUCCEED";
export const CREATE_PATIENT_REQUEST_FAILED =
  "src/PatientRegister/CREATE_PATIENT_REQUEST_FAILED";

export const SAVE_PROCEDURE_REQUEST_SENT =
  "src/PatientRegister/SAVE_PROCEDURE_REQUEST_SENT";
export const SAVE_PROCEDURE_REQUEST_SUCCEEDED =
  "src/PatientRegister/SAVE_PROCEDURE_REQUEST_SUCCEEDED";
export const SAVE_PROCEDURE_REQUEST_FAILED =
  "src/PatientRegister/SAVE_PROCEDURE_REQUEST_FAILED";

export const GET_FLOW_ID_REQUEST_SENT =
  "src/PatientRegister/GET_FLOW_ID_REQUEST_SENT";
export const GET_FLOW_ID_REQUEST_SUCCEED =
  "src/PatientRegister/GET_FLOW_ID_REQUEST_SUCCEED";
export const GET_FLOW_ID_REQUEST_FAILED =
  "src/PatientRegister/GET_FLOW_ID_REQUEST_FAILED";

export const GET_MODIFIER_REQUEST_SENT =
  "src/PatientRegister/GET_MODIFIER_REQUEST_SENT";
export const GET_MODIFIER_REQUEST_SUCCEED =
  "src/PatientRegister/GET_MODIFIER__REQUEST_SUCCEED";
export const GET_MODIFIER_REQUEST_FAILED =
  "src/PatientRegister/GET_MODIFIER__REQUEST_FAILED";

export const GET_FACILITY_REQUEST_SENT =
  "src/PatientRegister/GET_FACILITY_REQUEST_SENT";
export const GET_FACILITY_REQUEST_SUCCEED =
  "src/PatientRegister/GET_FACILITY__REQUEST_SUCCEED";
export const GET_FACILITY_REQUEST_FAILED =
  "src/PatientRegister/GET_FACILITY__REQUEST_FAILED";

export const PAGE_CHANGE = "src/PatientRegister/PAGE_CHANGE";

export const SET_QR_DETAILS = "src/PatientRegister/SET_QR_DETAILS";

export const SET_SIGNUP_DATA = "src/PatientRegister/SET_SIGNUP_DATA";
export const SET_SIGNUP_DATA_FOR_EXISTING_USER = "src/PatientRegister/SET_SIGNUP_DATA_FOR_EXISTING_USER";

export const SET_EMAIL_OTP_IN_STATE = "src/PatientRegister/SET_EMAIL_OTP_IN_STATE";

export const CLEAR_SIGNUP_DATA = "src/PatientRegister/CLEAR_SIGNUP_DATA";

export const SET_PHONE_OTP_IN_STATE = "src/PatientRegister/SET_PHONE_OTP_IN_STATE";
export const SET_USER_CONSENT = "src/PatientRegister/SET_USER_CONSENT";
export const SET_PROCEDURE_CONFIRMATION = "src/PatientRegister/SET_PROCEDURE_CONFIRMATION";
export const SET_EXISTING_USER_FLAG = "src/PatientRegister/SET_EXISTING_USER_FLAG";
export const GET_MODIFIER_AND_FACILITY_DATA_REQUEST_SENT = "app/PatientRegister/GET_MODIFIER_AND_FACILITY_DATA_REQUEST_SENT";
export const GET_MODIFIER_AND_FACILITY_DATA_REQUEST_SUCCEEDEED = "app/PatientRegister/GET_MODIFIER_AND_FACILITY_DATA_REQUEST_SUCCEEDEED";
export const GET_MODIFIER_AND_FACILITY_DATA_REQUEST_FAILED = "app/PatientRegister/GET_MODIFIER_AND_FACILITY_DATA_REQUEST_FAILED";

